export const userTypeQs = (input) =>
  input.indexOf("/acghr_hr") !== -1 ? "HR" : "SUPER";

export const isLoginPage = (input) =>
  input.indexOf("login") !== -1 ? true : false;
